import { nameTableColumn } from '../../constants/nameTableRso';

export const highlightedColumnsHandler = ({ state, value }) => {
  const { name, columnSelect } = value;

  const updated = [...state.highlightedColumns];
  const index =
    name === nameTableColumn.columnsAddressStart ||
    name === nameTableColumn.columnsAddressEnd
      ? updated.findIndex((c) => c.name === nameTableColumn.columnsAddress)
      : updated.findIndex((c) => c.name === name);

  if (index === -1) return { ...state };

  let newColumns = [];

  const startColumn =
    name === nameTableColumn.columnsAddressEnd
      ? updated.find((c) => c.name === nameTableColumn.columnsAddress)
          ?.column[0]
      : null;

  if (name === nameTableColumn.columnsAddressStart) {
    newColumns = columnSelect ? [columnSelect] : [];
  } else if (name === nameTableColumn.columnsAddressEnd) {
    if (!startColumn) return { ...state };

    const startIndex = state.columnLabels.findIndex(
      (c) => c.value === startColumn
    );

    const endIndex = state.columnLabels.findIndex(
      (c) => c.value === columnSelect
    );

    if (startIndex === -1) return { ...state };

    if (endIndex === -1 || !columnSelect) {
      newColumns = [state.columnLabels[startIndex].value];
    } else {
      newColumns = state.columnLabels
        .slice(startIndex, endIndex + 1)
        .map((c) => c.value);

      if (columnSelect) {
        const rangeSet = new Set(newColumns);

        for (let i = 0; i < updated.length; i++) {
          if (updated[i].name === nameTableColumn.columnsAddress) continue;
          const hasOverlap = updated[i].column.some((col) => rangeSet.has(col));
          if (hasOverlap) {
            updated[i] = { ...updated[i], column: [] };
          }
        }
      }
    }
  } else {
    newColumns = columnSelect ? [columnSelect] : [];
  }

  updated[index] = { ...updated[index], column: newColumns };

  return {
    ...state,
    highlightedColumns: updated,
  };
};
